import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Manager from './Manager';

const mapStateToProps = (state) => ({
  manager: state.user.user.manager || {},
});

export default connect(mapStateToProps)(injectIntl(Manager));
